"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTheme = exports.FONT_FAMILIES = void 0;
var UTILITY_COLORS = {
    BLUE: '#00808a',
    BLUE_LIGHT: '#d6ffff',
    GREEN: '#328731',
    GREEN_LIGHT: '#ebf6eb',
    ORANGE: '#d76e00',
    ORANGE_LIGHT: '#ffeec8',
    RED: '#eb0000',
    RED_LIGHT: '#ffd8d8'
};
var DISCOUNT_COLOR = '#3fae3e';
exports.FONT_FAMILIES = {
    condensed: 'VP Condensed Next, Impact, arial, sans-serif',
    text: 'HK Grotesk, arial, sans-serif',
    title: 'VP Next, arial, sans-serif'
};
// tslint:disable:object-literal-sort-keys
exports.defaultTheme = {
    name: 'veepee',
    border: {
        s100: '1px',
        s200: '2px'
    },
    breakpoint: {
        tablet: '641px',
        tabletMedium: '769px',
        desktop: '1025px',
        desktopHD: '1221px'
    },
    fontFamily: exports.FONT_FAMILIES,
    radius: {
        s100: '2px',
        s200: '4px',
        s300: '6px',
        s400: '100%'
    },
    shadow: {
        z1: '0 -1px 1px -1px rgba(34,34,43,0.08), 0 4px 8px -2px rgba(34,34,43,0.08), 0 1px 10px -2px rgba(34,34,43,0.10)',
        z2: '0 -1px 1px -1px rgba(34,34,43,0.12), 0 10px 14px -6px rgba(34,34,43,0.06), 0 4px 16px -4px rgba(34,34,43,0.12)',
        z3: '0 -1px 2px -2px rgba(34,34,43,0.16), 0 10px 14px -6px rgba(34,34,43,0.08), 0 4px 18px -2px rgba(34,34,43,0.10)',
        z4: '0 -1px 4px -2px rgba(34,34,43,0.08), 0 14px 16px -6px rgba(34,34,43,0.10), 0 4px 22px 0 rgba(34,34,43,0.10)',
        z5: '0 6px 16px 0 rgba(34,34,43,0.08), 0 8px 24px 0 rgba(34,34,43,0.16), 0 18px 36px 0 rgba(34,34,43,0.08)',
        zNav: '0 1px 0 0 rgba(240, 240, 240, 1)',
        /** @deprecated: use z1 instead */
        s100: '0 3px 11px 0 rgba(34,34,43,0.08)',
        /** @deprecated: use z2 instead */
        s200: '0 3px 11px 0 rgba(34,34,43,0.16)',
        /** @deprecated: use z3 instead */
        s300: '0 3px 11px 0 rgba(34,34,43,0.24)'
    },
    space: {
        // xxx_small
        s025: '.125rem',
        // xx_small
        s050: '.25rem',
        // x_small
        s100: '.5rem',
        // small
        s150: '.75rem',
        // default
        s200: '1rem',
        // medium
        s300: '1.5rem',
        // large
        s400: '2rem',
        // x_large
        s500: '2.5rem',
        // xx_large
        s600: '3rem',
        // xxx_large
        s700: '3.5rem',
        // xxxx_large
        s800: '4rem',
        // xxxxx_large
        s900: '4.5rem',
        // xxxxxx_large
        s1000: '5rem'
    },
    typography: {
        display: {
            small: {
                fontFamily: exports.FONT_FAMILIES.condensed,
                fontWeight: 400,
                fontSize: '1.625rem',
                lineHeight: 'normal'
            },
            medium: {
                fontFamily: exports.FONT_FAMILIES.condensed,
                fontWeight: 400,
                fontSize: '2rem',
                lineHeight: 'normal'
            },
            large: {
                fontFamily: exports.FONT_FAMILIES.condensed,
                fontWeight: 400,
                fontSize: '2.375rem',
                lineHeight: '48px'
            },
            x_large: {
                fontFamily: exports.FONT_FAMILIES.condensed,
                fontWeight: 400,
                fontSize: '2.625rem',
                lineHeight: '50px'
            }
        },
        heading: {
            heading: {
                fontFamily: exports.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '1.625rem',
                lineHeight: 'normal'
            },
            small: {
                fontFamily: exports.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '1.125rem',
                lineHeight: '26px'
            },
            subheading: {
                fontFamily: exports.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '1.25rem',
                lineHeight: '26px'
            }
        },
        section: {
            bigTitle: {
                fontFamily: exports.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '1.5rem',
                lineHeight: 'normal'
            },
            subtitle: {
                fontFamily: exports.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '1.125rem',
                lineHeight: '22px'
            },
            title: {
                fontFamily: exports.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '1.25rem',
                lineHeight: '30px'
            }
        },
        body: {
            text: {
                fontFamily: exports.FONT_FAMILIES.text,
                fontWeight: 500,
                fontSize: '1rem',
                lineHeight: '23px'
            },
            textMain: {
                fontFamily: exports.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '1rem',
                lineHeight: '23px'
            },
            boldText: {
                fontFamily: exports.FONT_FAMILIES.text,
                fontWeight: 600,
                fontSize: '1rem',
                lineHeight: '22px'
            },
            boldTextMain: {
                fontFamily: exports.FONT_FAMILIES.title,
                fontWeight: 700,
                fontSize: '1rem',
                lineHeight: '22px'
            },
            microText: {
                fontFamily: exports.FONT_FAMILIES.text,
                fontWeight: 500,
                fontSize: '0.625rem',
                lineHeight: '18px'
            },
            boldMicroText: {
                fontFamily: exports.FONT_FAMILIES.text,
                fontWeight: 600,
                fontSize: '0.625rem',
                lineHeight: '18px'
            },
            microTextMain: {
                fontFamily: exports.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '0.625rem',
                lineHeight: '18px'
            },
            boldMicroTextMain: {
                fontFamily: exports.FONT_FAMILIES.title,
                fontWeight: 700,
                fontSize: '0.625rem',
                lineHeight: '18px'
            },
            regularText: {
                fontFamily: exports.FONT_FAMILIES.text,
                fontWeight: 400,
                fontSize: '1rem',
                lineHeight: '23px'
            },
            regularTextMain: {
                fontFamily: exports.FONT_FAMILIES.title,
                fontWeight: 400,
                fontSize: '1rem',
                lineHeight: '23px'
            },
            smallText: {
                fontFamily: exports.FONT_FAMILIES.text,
                fontWeight: 500,
                fontSize: '0.875rem',
                lineHeight: '20px'
            },
            boldSmallText: {
                fontFamily: exports.FONT_FAMILIES.text,
                fontWeight: 600,
                fontSize: '0.875rem',
                lineHeight: '20px'
            },
            smallTextMain: {
                fontFamily: exports.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '0.875rem',
                lineHeight: '20px'
            },
            smallTextRegular: {
                fontFamily: exports.FONT_FAMILIES.text,
                fontWeight: 400,
                fontSize: '0.875rem',
                lineHeight: '18px'
            },
            boldSmallTextMain: {
                fontFamily: exports.FONT_FAMILIES.title,
                fontWeight: 700,
                fontSize: '0.875rem',
                lineHeight: '20px'
            },
            tinyText: {
                fontFamily: exports.FONT_FAMILIES.text,
                fontWeight: 500,
                fontSize: '0.75rem',
                lineHeight: '18px'
            },
            boldTinyText: {
                fontFamily: exports.FONT_FAMILIES.text,
                fontWeight: 600,
                fontSize: '0.75rem',
                lineHeight: '18px'
            },
            tinyTextMain: {
                fontFamily: exports.FONT_FAMILIES.title,
                fontWeight: 500,
                fontSize: '0.75rem',
                lineHeight: '18px'
            },
            tinyTextRegular: {
                fontFamily: exports.FONT_FAMILIES.text,
                fontWeight: 400,
                fontSize: '0.75rem',
                lineHeight: '18px'
            }
        }
    },
    colors: {
        main: {
            // primary
            base: '#ec008c',
            // dark
            tap: '#d90082',
            // light
            hover: '#ea51a3',
            // focus
            focus: 'rgba(234,81,163,0.40)'
        },
        accent: {
            base: '#ec008c'
        },
        text: {
            body: '#464650',
            title: '#22222B'
        },
        discount: {
            base: DISCOUNT_COLOR,
            premium: DISCOUNT_COLOR,
            savings: DISCOUNT_COLOR
        },
        status: {
            ok: UTILITY_COLORS.GREEN,
            error: UTILITY_COLORS.RED,
            info: UTILITY_COLORS.BLUE,
            warn: UTILITY_COLORS.ORANGE,
            light: {
                ok: UTILITY_COLORS.GREEN_LIGHT,
                error: UTILITY_COLORS.RED_LIGHT,
                info: UTILITY_COLORS.BLUE_LIGHT,
                warn: UTILITY_COLORS.ORANGE_LIGHT
            }
        },
        white: {
            // lightest
            s100: '#ffffff'
        },
        gray: {
            // lighter
            s200: '#f7f7f7',
            // light
            s300: '#e1e1e4',
            // gray
            s400: '#c8c8ca',
            // medium
            s500: '#a2a2a7',
            // medium_dark
            s600: '#7b7b7f',
            // dark
            s700: '#464650',
            // darker
            s800: '#22222b',
            // darkest
            s900: '#121217'
        },
        green: {
            s50: UTILITY_COLORS.GREEN_LIGHT,
            s75: DISCOUNT_COLOR,
            s100: UTILITY_COLORS.GREEN
        },
        orange: {
            s50: UTILITY_COLORS.ORANGE_LIGHT,
            s100: UTILITY_COLORS.ORANGE
        },
        blue: {
            s50: UTILITY_COLORS.BLUE_LIGHT,
            s100: UTILITY_COLORS.BLUE
        },
        red: {
            s50: UTILITY_COLORS.RED_LIGHT,
            s75: '#E55253',
            s100: UTILITY_COLORS.RED
        },
        gold: {
            s50: '#f1d776' // Privalia premium
        },
        /** @deprecated */
        primary: {
            primary: '#ec008c',
            dark: '#d90082',
            light: '#ea51a3'
        },
        /** @deprecated */
        utility: {
            success: '#3fae3e',
            error: '#ff0000',
            information: '#00a7ce',
            warning: '#f7ac00'
        },
        /** @deprecated */
        grayscale: {
            lightest: '#ffffff',
            lighter: '#f7f7f7',
            light: '#e1e1e4',
            gray: '#c8c8ca',
            medium: '#a2a2a7',
            medium_dark: '#7b7b7f',
            dark: '#464650',
            darker: '#22222b',
            darkest: '#121217'
        },
        /** @deprecated */
        global: {
            green: '#3fae3e',
            green_light: '#ebf6eb',
            orange: '#f7ac00',
            orange_light: '#ffeec8',
            blue_light: '#d6ffff',
            red_light: '#ffd8d8'
        }
    },
    overrides: {
        price: {
            colors: {
                unavailable: {
                    primary: '#22222b',
                    secondary: '#7b7b7f'
                }
            }
        }
    },
    /** @deprecated */
    variables: {
        breakpoints: {
            tablet_portrait: '641px',
            tablet_landscape: '769px',
            desktop: '1025px',
            desktop_large: '1221px'
        },
        fontFamily: {
            condensed: 'VP Condensed Next, Impact, arial, sans-serif',
            text: 'HK Grotesk, arial, sans-serif',
            title: 'VP Next, arial, sans-serif'
        },
        spacings: {
            component: {
                xxx_small: '2px',
                xx_small: '4px',
                x_small: '8px',
                small: '12px',
                default: '16px',
                medium: '24px',
                large: '32px',
                x_large: '40px',
                xx_large: '48px',
                xxx_large: '56px'
            },
            layout: {
                xx_small: '4px',
                x_small: '8px',
                small: '12px',
                default: '16px',
                medium: '24px',
                large: '32px',
                x_large: '40px',
                xx_large: '48px',
                xxx_large: '56px',
                xxxx_large: '64px',
                xxxxx_large: '72px',
                xxxxxx_large: '80px'
            }
        }
    }
};
// tslint:enable:object-literal-sort-keys
exports.default = exports.defaultTheme;
